import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SbkInvestDataService {
    private apiRoot = '/api';
    private servicePath = '/omni-integration-service';

    constructor(private readonly http: HttpClient) { }

    // Create MMF Account
    checkIfClientIsRegistered(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/sub-accounts`;
        return this.http.post(uri, payload);
    }

    openUnitTrustFundAccount(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/register-client`;
        return this.http.post(uri, payload);
    }

    createSubAccount(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/create-sub-account`;
        return this.http.post(uri, payload);
    }

    joinFund(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/join-fund`;
        return this.http.post(uri, payload);
    }

    // Get unit trust account transactions
    fetchUnitTrustAccountTransactions(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/transactions`;
        return this.http.post(uri, payload);
    }

    // Fetch unit trust accounts
    getUnitTrustAccounts(Channel: string): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/sub-accounts-detailed`;
        return this.http.post(uri, { Channel });
    }

    // Open savings account
    openSavingsAccount(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/account-services-integration-service/client-api/v1/account-services/secondary-account`;
        return this.http.post(uri, payload);
    }

    getSavingsAccountParams(): Observable<any> {
        const uri = `${this.apiRoot}/account-services-integration-service/client-api/v1/account-services/secondary-account-params`;
        return this.http.get(uri);
    }

    // Get unit trust statement
    getUnitTrustAccountStatement(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/email-statement`;
        return this.http.post(uri, payload);
    }

    // Withdraw from unit trust account
    withdrawFromUnitTrustAccount(payload: any): Observable<any> {
        const uri = `${this.apiRoot}/bb-mmf-integration/sell-units`;
        return this.http.post(uri, payload);
    }

    // Withdraw from unit trust account confirmation
    confirmWithdrawFromUnitTrustAccountStatus(payload: any, confirmationId: string): Observable<any> {
        const version = 'v2';
        const uri = `${this.apiRoot}${this.servicePath}/client-api/${version}/loans/apply`;

        const headers = new HttpHeaders({
            'X-CONFIRMATION-ID': confirmationId,
        });

        return this.http.post(uri, payload, { headers });
    }

    // Get unit trust fact sheets
    getUnitTrustFactSheets(): Observable<any> {
        const uri = '/api/contentservices/client-api/contentstream/portalRepository/custom/unit-funds';
        return this.http.get(uri);
    }
}
